import { loc } from "../i18n/survey";
import { locIconButton } from "./utils";

enum ScienceFamiliarity {
  Very = 'Very',
  Somewhat = 'Somewhat',
  Attempted = 'Attempted',
  NotAtAll = 'Not at all',
}

const scienceQuestion = {
  name: 'science',
  title: loc("quiz.science.title"),
  description: loc("quiz.shared.startingPoint"),
  type: 'radiogroup',
  choices: [
    {
      value: ScienceFamiliarity.Very,
      text: locIconButton("quiz.science.choices.very", "🧠"),
    },
    {
      value: ScienceFamiliarity.Somewhat,
      text: locIconButton("quiz.science.choices.somewhat", "📚"),
    },
    {
      value: ScienceFamiliarity.Attempted,
      text: locIconButton("quiz.science.choices.attempted", "🔍"),
    },
    {
      value: ScienceFamiliarity.NotAtAll,
      text: locIconButton("quiz.science.choices.notAtAll", "🤷"),
    },
  ],
  isRequired: true,
};

export {
  ScienceFamiliarity,
  scienceQuestion,
};